import { Injectable } from '@angular/core';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  public timeOnline: any;

  constructor(
    public webservice: WebservicesService
  ){}

  callTime() {
    return this.webservice.get('configuration/time');
  }

  setOnlineTime(onlineTime) {
    this.timeOnline = onlineTime;
  }

  getOnlineTime() {
    return this.timeOnline;
  }

  getServerTime(){
    return new Promise((resolve, reject) => {
      this.callTime().subscribe((serverTime) => {
        resolve(serverTime);
      }, (error) => {
        resolve(0);
      });
    });
  }

  getTimeOnline(timenow, timeloggedin) {
    var last_login = new Date(timeloggedin);
    var now = new Date(timenow * 1000);
    var diff = now.getTime() - last_login.getTime();
    var mil = Math.floor(diff);
    var seconds = (mil / 1000) | 0;
    mil -= seconds * 1000;
    var minutes = (seconds / 60) | 0;
    seconds -= minutes * 60;
    var hours = (minutes / 60) | 0;
    minutes -= hours * 60;
    var days = (hours / 24) | 0;
    hours -= days * 24;
    var time_on_site = "";
    if (hours > 0) {
      time_on_site = time_on_site + hours + "h ";
    }
    time_on_site = time_on_site + minutes + "m";
    return time_on_site;
  }

  reverseDate_YYYY_MM_DD(date) {
    let yyyy = date.slice(6, 10);
    let mm = date.slice(0, 2);
    let dd = date.slice(3, 5);

    let str = yyyy + "-" + mm + "-" + dd;

    return str;
  }

  formatDate_MM_DD_YYYY(date: Date) {
    let dd = date.getDate();
    let mm = date.getMonth() + 1; //January is 0!
    let yyyy = date.getFullYear();

    let str = "";

    if (mm < 10) {
      str += "0" + mm.toString() + "-";
    } else {
      str += mm.toString() + "-";
    }

    if (dd < 10) {
      str += "0" + dd.toString();
    } else {
      str += dd.toString();
    }

    str += "-" + yyyy.toString();

    //returns date as MM-DD-YYYY
    return str;
  }

  formatDateWithTextMonth(date: string, delimiter: string = " "): string {
    var tempDate1: any[] = date.split(delimiter);
    var tempDate2: any[] = tempDate1[0].split("-");
    var formattedDate: string =
      this.getMonthString(tempDate2[1]) +
      " " +
      tempDate2[2] +
      ", " +
      tempDate2[0];
    return formattedDate;
  }

  getMonthString(month: string): string {
    switch (month) {
      case "01":
        return "Jan";
      case "02":
        return "Feb";
      case "03":
        return "Mar";
      case "04":
        return "Apr";
      case "05":
        return "May";
      case "06":
        return "Jun";
      case "07":
        return "Jul";
      case "08":
        return "Aug";
      case "09":
        return "Sep";
      case "10":
        return "Oct";
      case "11":
        return "Nov";
      case "12":
        return "Dec";
    }

    return "";
  }
}
